// extracted by mini-css-extract-plugin
module.exports = {"root":"root--8delk","enable":"enable--m9usK","plus":"plus--m0fno","verify":"verify--HcATN"};